import React from 'react';
import { useField } from 'formik';
import cn from 'classnames';
import upd from 'immutability-helper';

import { Attach } from '../../composer-env';
import { DocIcon, Icons, Text, Wrapper } from 'widget/components';

import { useFormatSize } from './hooks';

interface FilePreview {
  attach: Attach;
  index: number;
}

const AttachPreview = ({ attach, index }: FilePreview) => {
  const [field, , helpers] = useField<File[]>('attachs');
  const formatSize = useFormatSize();

  const handleClick = () => {
    const newValue = upd(field.value, { $splice: [[index, 1]] });
    helpers.setValue(newValue);
  };

  const { file } = attach;
  const isDoc = !file.type.includes('image') && !file.type.includes('video');
  const size = formatSize(file.size);

  return (
    <div className="whatcrm-widget-attachs-preview__item">
      <div
        className={cn('whatcrm-widget-attachs-preview__content', {
          'whatcrm-widget-attachs-preview__content_doc': isDoc,
          'whatcrm-widget-attachs-preview__content_error': !attach.isValid,
        })}
      >
        {file.type.includes('image') ? (
          <img
            className="whatcrm-widget-attachs-preview__media"
            src={URL.createObjectURL(file)}
          />
        ) : file.type.includes('video') ? (
          <video
            autoPlay
            className="whatcrm-widget-attachs-preview__media"
            loop
            muted
            src={URL.createObjectURL(file)}
          />
        ) : (
          <Wrapper alignItems="center" gap={8} style={{ minWidth: 0 }}>
            <DocIcon filename={file.name} />

            <Text direction="rtl" isEllipsis>
              {file.name}
            </Text>
          </Wrapper>
        )}
      </div>

      {!attach.isValid && (
        <Text color="red" fontSize={12} isEllipsis maxWidth="100%">
          {size}
        </Text>
      )}

      <button
        className="whatcrm-widget-attachs-preview__btn"
        onClick={handleClick}
        type="button"
      >
        <Icons.CircleClose size={24} />
      </button>
    </div>
  );
};

export default AttachPreview;
